import * as React from "react";
const SvgFiRrFaceDowncastSweat = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-downcast-sweat_svg__a)">
      <path
        fill="#062147"
        d="M24 12c0 6.617-5.383 12-12 12S0 18.617 0 12c0-.733.066-1.467.198-2.181a1 1 0 0 1 1.967.361A10 10 0 0 0 2 11.999c0 5.514 4.486 10 10 10s10-4.486 10-10S17.514 2 12 2c-.927 0-1.844.127-2.728.376A1 1 0 1 1 8.728.453C9.789.153 10.89.001 12 .001c6.617 0 12 5.383 12 12zM8.403 17.198a.999.999 0 0 0 1.19 1.607C9.604 18.797 10.711 18 12 18s2.396.797 2.403.802a1 1 0 1 0 1.194-1.603c-.066-.049-1.632-1.198-3.597-1.198s-3.531 1.148-3.597 1.197M10 11H6a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2m8 2a1 1 0 1 0 0-2h-4a1 1 0 1 0 0 2zM3.5 7A2.5 2.5 0 0 0 6 4.5C6 3.097 4.816 1.128 4.078.265a.754.754 0 0 0-1.151.004C2.189 1.143 1 3.13 1 4.5A2.5 2.5 0 0 0 3.5 7"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-downcast-sweat_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceDowncastSweat;
